export const endpoints = {
	api: {
		auth: "auth",
		admin: "admin",

		getUserData: "getUserData",
		registerUser: "registerUser",
		web: "web/",
		login: "auth/login",
		logout: "auth/logout",
		register: "auth/register",
		recover: "recover",
		refresh: "refreshToken",
		dataUser: "dataUserWeb",
		recovery: "recovery",
		recoveryFinish: "recoveryFinish",
		
		admins: "admins",
		users: "users",
		user: "user",
		updateStatus: "updateStatus",
		edit: "edit",

		// NOTIFICATIONS
		notification: "notification",
		handleNotification: "handleNotification",
		deleteNotification: "deleteNotification",

		// NOTIFICACION TOKEN
		storeToken: "notification/storeToken",
	},
	countries: {
		url: "https://restcountries.com/v3.1/",
		all: "all",
		region: "region",
		alpha: "alpha",
	},
};
